export enum Country {
  US = 'US',
  CA = 'CA',
  MX = 'MX',
  Other = 'other',
}
